export default "__VITE_ASSET__c6e21add__"